import { FETCH_SHARE_DATA_FAIL, FETCH_SHARE_DATA_REQUEST, FETCH_SHARE_DATA_SUCCESS, SEND_SHARE_DATA_FAIL, SEND_SHARE_DATA_REQUEST, SEND_SHARE_DATA_SUCCESS } from "../../ActionType/SharedType/sharedDataType";

export const sendSharedDataReducer = (state = { loading: false }, action) => {
  switch (action.type) {
    case SEND_SHARE_DATA_REQUEST:
      return {
        loading: true,
      };

    case SEND_SHARE_DATA_SUCCESS:
      return {
        loading: false,
      };

    case SEND_SHARE_DATA_FAIL:
      return {
        loading: false,
      };
    default:
      return state;
  }
};


export const getSharedDataReducer = (state = { loading: true,token:"" }, action) => {
    switch (action.type) {
      case FETCH_SHARE_DATA_REQUEST:
        return {
          loading: true,
        };
  
      case FETCH_SHARE_DATA_SUCCESS:
        return {
          loading: false,
          token:action.payload,
          
        };
  
      case FETCH_SHARE_DATA_FAIL:
        return {
          loading: false,
          token:"",
        };
      default:
        return state;
    }
  };
